<template>
  <div class="mb-5">
    <div v-if="!isAuthenticated">
      <b-jumbotron bg-variant="info">
        <template slot="header">
          <div class="text-white">CRT Hub</div>
        </template>
        <template slot="lead">
          <h3 class="text-white">An Open Environment for Data, Tools and Analytics</h3>
        </template>
      </b-jumbotron>
      <b-row>
        <b-col cols="6" class="text-justify">
          <h3>{{ isEmpirasignUser ? 'Welcome Empirasign Users' : 'Welcome!' }}</h3>
          <p>
            CRT Hub provides cashflows and analytics on Credit Risk Transfer structured transactions including Bonds (STACR/CAS);
            Reinsurance Products (ACIS/CIRT) and Mortgage Insurance (MI-ILN).
            CRT Hub allows users to evaluate their CRT positions using static CPR/CDR; proprietary vectors and scenarios;
            or through integration with third party predictive modeling.
          </p>
          <p>
            To receive a complimentary [30 day] trial of CRT Hub's Deal Analysis and Bond Analysis features for STACR and CAS securitizations,
            please provide the requested information. To get more information about CRT Hub, access to advanced features or to schedule a tour of the site,
            please contact us at <a href="mailto:info@chasenenterprises.com">info@chasenenterprises.com</a>
            <!-- select the More Info button (link). -->
          </p>
          <p>
            - The CRT Hub Team
          </p>
        </b-col>
        <b-col style="max-width: 60%">
          <b-form-group label-cols="3" label="First name" label-for="firstName" label-class="text-right">
            <b-form-input id="firstName" v-model="firstName"></b-form-input>
          </b-form-group>
          <b-form-group label-cols="3" label="Last Name" label-for="lastName" label-class="text-right">
            <b-form-input id="lastName" v-model="lastName"></b-form-input>
          </b-form-group>
          <b-form-group label-cols="3" label="Company" label-for="companyName" label-class="text-right">
            <b-form-input id="companyName" v-model="companyName"></b-form-input>
          </b-form-group>
          <b-form-group label-cols="3" label="Email" label-for="email" label-class="text-right">
            <b-form-input id="email" type="email" v-model="email"></b-form-input>
          </b-form-group>
          <b-form-group label-cols="3" label="CRT Hub Userid" label-for="userName" label-class="text-right">
            <b-form-input id="userName" v-model="userName"></b-form-input>
          </b-form-group>
          <b-form-group label-cols="3" label="Password" label-for="pwd" label-class="text-right">
            <b-input-group>
              <b-form-input id="pwd" :type="userPasswordType" v-model="userPassword" required placeholder="Password" size="sm"></b-form-input>
              <b-input-group-append>
                <b-button variant="info"
                          @mousedown="userPasswordType = 'text'"
                          @mouseup="userPasswordType = 'password'"
                          class="pwd-btn">
                  <b-icon-eye-slash v-if="userPasswordType == 'password'"></b-icon-eye-slash>
                  <b-icon-eye-fill v-else></b-icon-eye-fill>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group label-cols="3" label="Confirm Password" label-for="cpwd" label-class="text-right">
            <b-input-group>
              <b-form-input id="cpwd" :type="confirmationPasswordType" v-model="confirmPassword" required placeholder="Confirm password" size="sm"></b-form-input>
              <b-input-group-append>
                <b-button variant="info"
                          @mousedown="confirmationPasswordType = 'text'"
                          @mouseup="confirmationPasswordType = 'password'"
                          class="pwd-btn">
                  <b-icon-eye-slash v-if="confirmationPasswordType == 'password'"></b-icon-eye-slash>
                  <b-icon-eye-fill v-else></b-icon-eye-fill>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-row>
            <b-col cols="3"/>
            <b-col>
              <b-btn variant="primary" @click="registerUser">Register</b-btn>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <div class="footer">
        <p>2020 &copy; Chasen Enterprises. All Rights Reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
import service                from '../services/HttpRequestService';
import RedirectWithCusipMixin from './RedirectWithCusipMixin';
import ManagerRequest         from "@/services/ManagerRequest";
import ObjSpinnerState        from "@/components/common/spinner/ObjSpinnerState";
import ObjAlertState          from "@/components/common/alert/ObjAlertState";

export default {
  mixins: [RedirectWithCusipMixin],
  data() {
    return {
      firstName:                '',
      lastName:                 '',
      companyName:              '',
      userName:                 '',
      email:                    '',
      userPassword:             '',
      userPasswordType:         'password',
      confirmPassword:          '',
      confirmationPasswordType: 'password',
      errors:                   []
    };
  },
  props:    {
    basedOnCusip: {
      type:    Boolean,
      default: true
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.authenticated;
    },
    isEmpirasignUser() {
      return this.$route.query.utm_source === 'empirasign';
    }
  },
  methods:  {
    async redirectToLoginIfUserWithAuidExists() {
      const auid = this.$route.query.auid;
      if (auid) {
        const flagUserExists = await (new ManagerRequest(
            service.checkIfUserExistsByAuid,
            service,
            null
        ))
            .do(
                auid
            );
        if (flagUserExists) {
          this.$router.push({path: '/', query: this.$route.query});
        }
      }
    },
    checkForm() {
      this.errors = [];

      if (!this.userName) {
        this.errors.push('Provide CRT Hub Userid.');
      }
      if (!this.email) {
        this.errors.push('Provide email.');
      } else if (!this.validEmail(this.email)) {
        this.errors.push('Provide valid email.');
      }

      if (!this.userPassword) {
        this.errors.push('Provide password.');
      }
      if (!this.confirmPassword) {
        this.errors.push('Provide password confirmation.');
      }

      if (!this.firstName) {
        this.errors.push('Provide first name.');
      }

      if (!this.lastName) {
        this.errors.push('Provide last name.');
      }

      if (!this.companyName) {
        this.errors.push('Provide company name.');
      }

      if (this.errors.length) {
        return false;
      }
      return true;
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    async registerUser() {
      ObjSpinnerState.isOn = true
      let validForm        = this.checkForm();

      if (!validForm) {
        ObjAlertState.set(this.errors.join('<br>'), 3);
        ObjSpinnerState.isOn = false
        return;
      }
      let roles = ['User'];
      let aHash = await (new ManagerRequest(
          service.registerUser,
          service,
          null
      ))
          .do(
              this.userName,
              this.email,
              this.userPassword,
              this.confirmPassword,
              this.firstName,
              this.lastName,
              this.companyName,
              roles,
              this.$route.query.auid
          );
      if (aHash) {
        let dataLogin = await (new ManagerRequest(
            service.authenticate,
            service,
            null
        ))
            .do(
                this.userName,
                this.userPassword
            );
        if (dataLogin) {
          dataLogin.username = this.userName;
          this.$store.commit('login', dataLogin);
          this.redirectToNextPage(this.basedOnCusip);
        }
      }
    }
  },
  created() {
    let query = this.$route.query;
    if (this.$route.path === '/trial/') {
      this.$router.push({path: '/trial'});
      this.$router.push({query: query});
    }
    if (this.isAuthenticated) {
      this.redirectToNextPage();
    } else {
      this.redirectToLoginIfUserWithAuidExists();
    }
  },
  components: {
  }
};
</script>

<style lang="scss" scoped>
.info-button {
  width: 100%;
  white-space: normal;
  font-size: 20px !important;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  line-height: 50px;
  vertical-align: middle;
  color: white;
  background-color: #17a2b8;
}
</style>
